let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kKFqa")).then(() => parcelRequire('cmTE1'));